import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  convertDateToObj,
  getAsOfDate,
  getCalenderDate,
  isCustomDate,
  padNumber,
} from "../../utils/functions";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import DatePicker2 from "../Reports/DatePicker2";
import { useParams } from "react-router";
import DurationTabs from "./DurationTabs";

const InternalTabs = ({
  tabsDataProp,
  selectedTab,
  setSelectedTab,
  isAnalytics,
  page,
  selectedIndex = 0,
  setSelectedIndex = () => {},
}) => {
  const { performanceRoute2 } = useParams();

  const tabs = tabsDataProp?.map((data) => data);
  // remove last tab in here , for further operation
  // tabsDataProp is used to display and tabs are used to conditionally handle tab selection
  PerformanceStore.selectedAssetClass.id !== 6 && tabs.pop();

  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);

  const handleTimePeriodReset = () => {
    PerformanceStore.setData("fromDatePerf", initialFromDate);
    PerformanceStore.setData("toDatePerf", initialToDate);
  };

  const applyDateFilter = ({ isDateChanged, eventName }) => {
    function getDuration() {
      return page === "assetPage"
        ? PerformanceStore.selectedDuration
        : PerformanceStore.secPageSelectedDuration;
    }
    const datestr = `${getCalenderDate(
      PerformanceStore.fromDatePerf,
    )}-${getCalenderDate(PerformanceStore.toDatePerf)}`;

    if (
      isDateChanged ||
      (PerformanceStore.lastTabName !== "CUSTOM" &&
        getDuration() === PerformanceStore.lastTabName)
    ) {
      PerformanceStore.setLoaderClosingCheck({});
      PerformanceStore.setCurrentLoader("inTableLoader");
      PerformanceStore.setPerformanceLoader("inTableLoader", true);

      const localLastTab = eventName
        ? eventName.eventName
        : PerformanceStore.selectedEvent.eventName;

      const lastTab =
        localLastTab === "Event not selected" ? datestr : localLastTab;

      page === "assetPage"
        ? PerformanceStore.setDuration(lastTab)
        : PerformanceStore.setSecPageDuration(lastTab);
      PerformanceStore.setData("lastTabName", lastTab);

      if (page === "assetPage") {
        PerformanceStore.selectedAssetClass.id !== 6
          ? PerformanceStore.getCustomDateData()
          : PerformanceStore.getDerivatesData();
      } else {
        const route = performanceRoute2?.split("_");
        PerformanceStore.selectedAssetClass.id !== 6
          ? PerformanceStore.getCustomDataSubAssetClass(route?.[1])
          : PerformanceStore.onInternalTabChangeSecPageDerivativeOrRedirect(
              PerformanceStore.transacSelection,
              PerformanceStore.optionSelection,
              performanceRoute2,
            );
      }
      eventName && PerformanceStore.setData("selectedEvent", eventName);
    } else {
    }
    setDatePickerModalOpen(false);
  };

  const handleClick = ({ tabs, setSelectedTab, tabsData, index }) => {
    const allTabs = tabs.join("").includes(tabsData);

    setSelectedTab(tabsData, index, allTabs);

    const asOfDateObj = convertDateToObj(getAsOfDate(UserStore.asOfDate));
    PerformanceStore.setData(
      "fromDatePerf",
      PerformanceStore.fromDatePerf
        ? PerformanceStore.fromDatePerf
        : asOfDateObj,
      "abc",
    );
    PerformanceStore.setData(
      "toDatePerf",
      PerformanceStore.toDatePerf ? PerformanceStore.toDatePerf : asOfDateObj,
      "bbc",
    );

    setSelectedIndex(index);

    PerformanceStore.lastTabName !== "CUSTOM" &&
      !isCustomDate(PerformanceStore.lastTabName) &&
      (function () {
        PerformanceStore.setData("selectedEvent", {
          eventName: PerformanceStore.lastTabName,
        });
      })();
    !allTabs && setDatePickerModalOpen(true);
  };

  const handleTimePeriodChange = (selectedTimePeriod) => {};

  useEffect(() => {
    if (datePickerModalOpen) {
      setInitialFromDate(PerformanceStore.fromDatePerf);
      setInitialToDate(PerformanceStore.toDatePerf);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen]);

  useEffect(() => {
    if (UserStore.isHydrated && PerformanceStore.isHydrated) {
      let as_of_date = getAsOfDate(UserStore.asOfDate);
      if (!getAsOfDate(UserStore.asOfDate)) as_of_date = getAsOfDate();
      let newTodate;
      let formattedTodate;
      if (!resetedFromDate && !resetedToDate) {
        newTodate = new Date(UserStore.forReportsInceptionDate);
        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());
        setResetedFromDate(convertDateToObj(formattedTodate));
        setResetedToDate(convertDateToObj(as_of_date));
      }
    }
  }, [UserStore.isHydrated, PerformanceStore.isHydrated]);

  useEffect(() => {
    if (selectedTab) {
      const index = tabsDataProp?.findIndex((data) => data === selectedTab);
      setSelectedIndex(index !== -1 ? index : 6);
    }
  }, [tabsDataProp]);

  return (
    <div className="int_tab_wrapper date_picker_wrapper">
      <div className="internal_tabs_main">
        {" "}
        {/* <div className="tabs int_tabs performance">
          <ul className={isAnalytics ? "analytics_ul" : ""}>
            {isAnalytics
              ? tabsDataProp.map((tabsData, index) => (
                  <li
                    key={index}
                    className={
                      selectedTab && selectedTab === tabsData?.name
                        ? "is-active darkBlueTextColor"
                        : selectedTab === "" && index === 0
                          ? "is-active darkBlueTextColor"
                          : "blueTextColor"
                    }
                    onClick={() => {
                      setSelectedTab(tabsData?.name, index);
                    }}
                  >
                    <button>{tabsData?.name}</button>
                  </li>
                ))
              : tabsDataProp.map((tabsData, index) => (
                  <li
                    key={tabsData}
                    className={
                      selectedTab &&
                      (selectedTab === tabsData ||
                        selectedTab === setDerivativeTabKeys(index))
                        ? "is-active darkBlueTextColor"
                        : selectedTab === "" && index === 0
                          ? "is-active darkBlueTextColor"
                          : "blueTextColor"
                    }
                    onClick={() =>
                      handleClick({ tabs, setSelectedTab, tabsData, index })
                    }
                  >
                    <button>
                      {!derivativeFixTab?.includes(tabsData)
                        ? tabsData
                        : PerformanceStore.subTabs?.[
                            derivativeTabs.indexOf(tabsData)
                          ]}
                    </button>
                  </li>
                ))}
          </ul>
        </div> */}
        <DurationTabs
          tabs={tabsDataProp}
          selectedTab={selectedTab}
          selectedIndex={selectedIndex}
          handleTab={({ tab, index }) =>
            handleClick({ tabs, setSelectedTab, tabsData: tab, index })
          }
        />
      </div>
      {true && (
        <div className={`inactive ${selectedTab === "CUSTOM" ? "active" : ""}`}>
          <DatePicker2
            parentComp="tabs"
            timePeriod={"custom"}
            fromDate={PerformanceStore.fromDatePerf}
            toDate={PerformanceStore.toDatePerf}
            setFromDate={(data) =>
              PerformanceStore.setData("fromDatePerf", data)
            }
            setToDate={(data) => PerformanceStore.setData("toDatePerf", data)}
            initialFromDate={initialFromDate}
            initialToDate={initialToDate}
            resetedFromDate={resetedFromDate}
            resetedToDate={resetedToDate}
            handleReset={handleTimePeriodReset}
            isActive={true}
            open={datePickerModalOpen}
            setOpen={() => {
              handleTimePeriodChange("custom");

              setDatePickerModalOpen(true);
            }}
            onClose={applyDateFilter}
            events={true}
            modalClass="custom_events"
          />
        </div>
      )}
    </div>
  );
};

export default observer(InternalTabs);
